<!-- 第一版采购单编辑 (已废弃)-->
<template>
    <div class="business-content-main">
        <div style="margin-right: 80px">
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   form     -->
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息</span>&nbsp;&nbsp;&nbsp;&nbsp;
                    <span v-show="!showOrderMsg && submitData.EntpCusName">供应商：{{ submitData.EntpCusName }}</span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showReceipt()" v-if="permission.pay && (type == 1 || type == 2 || type == 5 || type == 7)">{{
                        type == 5 ? permission.pay : '付款记录'
                    }}</el-button>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="inputWarehouse()"
                        v-if="(permission.goodsInAll || permission3.buyIn) && !submitData.IsInStorage && canInStorages && type == 6"
                        >整单入仓</el-button
                    >
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="!dataReadonly && (type == 2 || type == 3) && permission.addSupplier">{{
                        permission.addSupplier
                    }}</el-button>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="addCustomer(2)"
                        v-if="!dataReadonly && (type == 2 || type == 3) && submitData.EntpCusId && permission.editSupplier"
                        >{{ permission.editSupplier }}</el-button
                    >
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="search-ctn" v-show="showOrderMsg">
                <el-form :model="submitData" ref="formMsg" label-width="100px" style="width: 100%; padding-right: 30px" :rules="rules">
                    <div class="form-main" style="width: 100%">
                        <el-form-item label="选择供应商" prop="EntpCusId">
                            <el-input v-if="type == 4" :disabled="true" v-model.trim="submitData.EntpCusName"></el-input>
                            <el-select
                                v-else
                                :disabled="dataReadonly"
                                :loading="loading"
                                v-model="submitData.EntpCusId"
                                filterable
                                clearable
                                remote
                                reserve-keyword
                                :remote-method="searchCustomer"
                                @change="customerChange($event)"
                                @visible-change="customerVisibleChange($event)"
                                placeholder="选择供应商"
                            >
                                <el-option
                                    v-for="(optionItem, index) in customerList"
                                    :key="index"
                                    :data-msg="optionItem"
                                    :label="optionItem.EntpCusName"
                                    :value="optionItem.EntpCusId"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="采购员" prop="SId">
                            <el-select v-model="submitData.SId" :disabled="dataReadonly" filterable placeholder="请选择">
                                <el-option v-for="(item, index) in SIdList" :key="index" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="运输费用" prop="ShipAmount">
                            <el-input type="number" step="0.01" :disabled="dataReadonly" min="0" v-model.trim="submitData.ShipAmount"></el-input>
                        </el-form-item>
                        <el-form-item label="发货方式">
                            <el-select v-model="submitData.ShipType" :disabled="dataReadonly" placeholder="请选择">
                                <el-option v-for="(item, index) in DeliveryMethodList" :key="index" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="结算方式" prop="PayType">
                            <el-select v-model="submitData.PayType" :disabled="dataReadonly" placeholder="请选择">
                                <el-option v-for="(item, index) in payWayList" :key="index" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="form-bottom">
                        <div class="addresscls">
                            <el-form-item label="入仓仓库" prop="WarehouseId" style="width: 40%">
                                <el-input
                                    v-if="dataReadonly || ((submitData.IsPartialInWarehouse || submitData.IsInStorage) && warehouseList.length == 1)"
                                    :title="submitData.WarehouseName"
                                    v-model="submitData.WarehouseName"
                                    style="width: 100%"
                                    :disabled="true"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    v-model="submitData.WarehouseId"
                                    placeholder="请选择"
                                    filterable
                                    clearable
                                    @visible-change="warehouseVisibleChange($event)"
                                    @change="warehouseChange"
                                >
                                    <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                        <span style="float: left">{{ item.WarehouseName }}</span>
                                        <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="仓库地址" prop="WarehouseAddr" style="width: 60%">
                                <el-input
                                    v-if="canNotEditAddr"
                                    :title="submitData.WarehouseAddr"
                                    v-model="submitData.WarehouseAddr"
                                    :disabled="true"
                                    style="width: 100%"
                                ></el-input>
                                <el-input
                                    v-else-if="dataReadonly || ((submitData.IsPartialInWarehouse || submitData.IsInStorage) && !submitData.ShipAddr)"
                                    :title="submitData.WarehouseAddr"
                                    v-model="submitData.WarehouseAddr"
                                    style="width: 100%"
                                    :disabled="true"
                                ></el-input>
                                <el-input v-else :title="submitData.WarehouseAddr" v-model="submitData.WarehouseAddr" style="width: 100%"></el-input>
                            </el-form-item>
                        </div>
                        <div>
                            <el-form-item label="备注" style="width: 100%">
                                <el-input style="width: 100%" :title="submitData.Remark" :disabled="dataReadonly" v-model.trim="submitData.Remark"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    商品明细
                    <span v-if="type == 7" style="font-size: 14px; margin-left: 10px; color: red">（ 温馨提醒：已入仓的商品不能再进行修改！ ）</span>
                </div>
                <div>
                    <el-button
                        size="small"
                        class="search-btn btn-primary"
                        @click="showSearch()"
                        v-if="!dataReadonly && (type == 2 || type == 3 || type == 7) && permission.searchAP"
                        >搜索配件</el-button
                    >
                </div>
            </div>
            <div class="edit-ctn">
                <!--      table title      -->
                <div @click="hideMsg()" class="div-table-row table-title">
                    <div class="div-table-cell" style="width: 5%">序号</div>
                    <div class="div-table-cell" style="width: 15%; flex-grow: 1"><span class="color-red">*</span>汽配编码</div>
                    <div class="div-table-cell" style="width: 18%"><span class="color-red">*</span>配件名称</div>
                    <div class="div-table-cell" style="width: 20%"><span class="color-red">*</span>车型</div>
                    <div class="div-table-cell" style="width: 7.5%">数量</div>
                    <div class="div-table-cell" style="width: 7%"><span class="color-red">*</span>单位</div>
                    <div class="div-table-cell" style="width: 10%"><span class="color-red">*</span>采购价</div>
                    <div class="div-table-cell" style="width: 7.5%">采购总价</div>
                    <div class="div-table-cell" style="width: 5%" v-if="type == 6 || type == 1">
                        <el-tooltip effect="dark" placement="bottom" v-if="type == 6">
                            <div slot="content">不显示入仓按钮的情况：1.商品已入仓，2.已打标签，但标签未入仓</div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span> </el-tooltip
                        >入仓
                    </div>
                    <div class="div-table-cell" style="width: 10%" v-if="type == 2 || type == 3 || type == 7"></div>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div
            id="infinite-list"
            class="infinite-list"
            :style="{ height: infiniteListHeight + 'px' }"
            v-infinite-scroll="loadDownScroll"
            infinite-scroll-distance="10"
            :infinite-scroll-immediate="false"
        >
            <div class="edit-ctn">
                <div @click="hideMsg()" class="table-main">
                    <div v-for="(item, index) in dataList" :key="index" style="margin-right: 80px">
                        <div v-if="index >= startIdx && index <= endIdx" class="div-table-row table-item" :ref="'pj' + index">
                            <div class="div-table-cell" style="width: 5%">{{ index + 1 }}</div>
                            <!--        编码            -->
                            <div class="div-table-cell div-table-cell-code" style="width: 15%; flex-grow: 1" :class="{ 'check-code-class': item.CodeRepeat }">
                                <img src="../../../assets/images/info.png" alt="" title="配件信息" class="info-icon" @click="showAPMsgDialog(item.EntpTempGoodsId)" />
                                <el-select
                                    :ref="'code' + index"
                                    :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                    :loading="loading"
                                    allow-create
                                    default-first-option
                                    size="small"
                                    v-model="item.APCode"
                                    value-key="APCode"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="汽配编码"
                                    @focus="hideMsg"
                                    @change="codeChange($event, index)"
                                    @visible-change="apCodeVisibleChange($event)"
                                    @keyup.enter.native="addItem(true)"
                                    :remote-method="searchCode"
                                    style="width: 100%"
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option
                                        v-for="optionItem in codeList"
                                        :key="optionItem.EntpTempGoodsId"
                                        :data-msg="optionItem"
                                        :label="optionItem.APCode"
                                        :value="optionItem.APCode"
                                    >
                                        <div class="option-content">
                                            <div class="project-Name">{{ optionItem.APCode }}</div>
                                            <div class="project-Name">{{ optionItem.GoodName }}</div>
                                            <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                            <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                        </div>
                                    </el-option>
                                </el-select>
                                <div v-if="item.State == 1" class="row-delete">已删除</div>
                            </div>
                            <!--        名称            -->
                            <div class="div-table-cell" style="width: 18%">
                                <el-input
                                    style="width: 100%"
                                    size="small"
                                    v-model="item.GoodName"
                                    v-if="item.IsNew"
                                    :disabled="dataReadonly || type == 4 || (type == 7 && item.IsInStorage)"
                                    placeholder="配件名称"
                                ></el-input>
                                <el-select
                                    v-else
                                    style="width: 100%"
                                    :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                    :loading="loading"
                                    allow-create
                                    size="small"
                                    v-model="item.GoodName"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="配件名称"
                                    @focus="hideMsg"
                                    @change="nameChange($event, index)"
                                    @visible-change="apNameVisibleChange($event)"
                                    @keyup.enter.native="addItem(true)"
                                    :remote-method="
                                        query => {
                                            searchName(query, item);
                                        }
                                    "
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option
                                        v-for="optionItem in nameList"
                                        :key="optionItem.EntpTempGoodsId"
                                        :data-msg="optionItem"
                                        :label="optionItem.GoodName"
                                        :value="optionItem.GoodName"
                                    >
                                        <div class="option-content">
                                            <div class="project-Name">{{ optionItem.GoodName }}</div>
                                            <div class="project-Name">{{ optionItem.APCode }}</div>
                                            <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                            <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                        </div>
                                    </el-option>
                                </el-select>
                            </div>
                            <!--        车系            -->
                            <div class="div-table-cell" style="width: 20%">
                                <el-tooltip effect="dark" :content="item.AutoSerise ? item.AutoSerise.toString() : ''" :disabled="!item.AutoSerise" placement="top">
                                    <el-input
                                        style="width: 100%"
                                        size="small"
                                        v-model="item.AutoSerise"
                                        v-if="item.IsNew"
                                        :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                        placeholder="车系"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                        :loading="loading"
                                        allow-create
                                        size="small"
                                        v-model="item.AutoSeriseItem"
                                        value-key="EntpTempGoodsId"
                                        :title="item.AutoSerise"
                                        filterable
                                        clearable
                                        remote
                                        reserve-keyword
                                        placeholder="车系"
                                        @focus="hideMsg"
                                        @visible-change="autoSeriseVisibleChange($event, item)"
                                        @keyup.enter.native="addItem(true)"
                                        :remote-method="
                                            query => {
                                                searchAutoSerie(query, item);
                                            }
                                        "
                                        @change="seriseChange($event, index)"
                                        style="width: 100%"
                                        popper-class="el-select-style-gray"
                                    >
                                        <el-option v-for="option in seriesList" :key="option.EntpTempGoodsId" :data-msg="option" :label="option.AutoSerise" :value="option">
                                            <div class="option-content">
                                                <div class="project-Name" style="width: 300px">{{ option.AutoSerise }}</div>
                                                <div class="project-Name">{{ option.GoodName }}</div>
                                                <div class="project-Name">{{ option.APCode }}</div>
                                            </div>
                                        </el-option>
                                    </el-select>
                                </el-tooltip>
                            </div>
                            <!--        数量            -->
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-input
                                    type="number"
                                    :ref="'count' + index"
                                    :min="1"
                                    size="small"
                                    v-model="item.Count"
                                    @focus="hideMsg"
                                    @change="priceChange"
                                    @keyup.enter.native="addItem(true)"
                                    :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                ></el-input>
                            </div>
                            <!--        单位         -->
                            <div class="div-table-cell" style="width: 7%">
                                <el-select
                                    :disabled="dataReadonly || type == 4 || (type == 7 && item.WarehousedCount > 0)"
                                    allow-create
                                    default-first-option
                                    size="small"
                                    v-model="item.Unit"
                                    filterable
                                    clearable
                                    remote
                                    reserve-keyword
                                    placeholder="单位"
                                    @visible-change="unitVisibleChange($event)"
                                    @focus="hideMsg"
                                    @keyup.enter.native="addItem(true)"
                                    popper-class="el-select-style-gray"
                                >
                                    <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                                </el-select>
                            </div>
                            <!--          采购价          -->
                            <div class="div-table-cell" style="width: 10%">
                                <el-input-number
                                    size="small"
                                    :min="0"
                                    :precision="2"
                                    :step="0.01"
                                    controls-position="right"
                                    v-model="item.Price"
                                    :disabled="dataReadonly || (type == 7 && item.WarehousedCount > 0)"
                                    @input="priceChange"
                                    @focus="hideMsg"
                                    @keyup.enter.native="addItem(true)"
                                    placeholder="采购价"
                                ></el-input-number>
                            </div>
                            <!--          采购总价          -->
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-tooltip effect="dark" placement="top" :content="(item.Price * item.Count ? (item.Price * item.Count).toFixed(2) : 0).toString()">
                                    <span>
                                        {{ item.Price * item.Count ? (item.Price * item.Count).toFixed(2) : 0 }}
                                    </span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="(type == 6 || type == 1) && (permission.goodsIn || permission3.buyIn)">
                                <el-button
                                    @click="inputWarehouse(item)"
                                    size="mini"
                                    class="search-btn btn-primary"
                                    style="margin-left: 0"
                                    v-if="
                                        (permission.goodsIn || permission3.buyIn) &&
                                        (item.WarehousedCount > item.InLabelCount
                                            ? item.Count - item.PrintCount - (item.WarehousedCount - item.InLabelCount) > 0
                                            : item.Count - item.PrintCount > 0) &&
                                        type == 6
                                    "
                                    >入仓</el-button
                                >
                                <span v-if="type == 1">
                                    <el-tooltip effect="dark" placement="top" :content="item.IsInStorage ? '已入仓' : item.WarehousedCount > 0 ? '部分入仓' : '未入仓'">
                                        <span>
                                            {{ item.IsInStorage ? '已入仓' : item.WarehousedCount > 0 ? '部分入仓' : '未入仓' }}
                                        </span>
                                    </el-tooltip>
                                </span>
                            </div>
                            <div class="div-table-cell" style="width: 10%" v-if="type == 2 || type == 3 || type == 7">
                                <el-button title="销售数据" size="mini" type="text" @click="showSaleStat(item)">销售数据</el-button>
                                <el-button size="mini" type="text" @click="showHistories(item.EntpTempGoodsId)">采购历史</el-button>
                            </div>
                            <el-button
                                class="less-btn"
                                icon="el-icon-minus"
                                circle
                                @click="delItem(index)"
                                v-if="type == 7 ? item.WarehousedCount == 0 : !dataReadonly && (type == 2 || type == 3)"
                            ></el-button>
                        </div>
                    </div>
                    <div class="infinite-loading" v-if="showInfiniteLoading">
                        加载中
                        <i class="el-icon-loading"></i>
                    </div>
                    <div style="margin-right: 80px" v-else>
                        <div class="div-table-row table-item">
                            <div class="div-table-cell" style="width: 5%"></div>
                            <div class="div-table-cell" style="width: 15%; flex-grow: 1"></div>
                            <div class="div-table-cell" style="width: 18%"></div>
                            <div class="div-table-cell" style="width: 20%">总数量</div>
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-tooltip effect="dark" placement="top" :content="allNum.toString()">
                                    <span>{{ allNum }}</span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 7%"></div>
                            <div class="div-table-cell" style="width: 10%">合计</div>
                            <div class="div-table-cell" style="width: 7.5%">
                                <el-tooltip effect="dark" placement="top" :content="allMoney.toFixed(3).toString()">
                                    <span>{{ allMoney.toFixed(3) }}</span>
                                </el-tooltip>
                            </div>
                            <div class="div-table-cell" style="width: 5%" v-if="type == 6 || type == 1"></div>
                            <div class="div-table-cell" style="width: 10%" v-if="type == 2 || type == 3 || type == 7"></div>
                        </div>
                        <el-button
                            class="add-btn"
                            type="primary"
                            icon="el-icon-plus"
                            circle
                            @click="addItem(true)"
                            v-if="!dataReadonly && (type == 2 || type == 3 || type == 7)"
                        ></el-button>
                    </div>
                </div>
                <div class="btn-ctn" v-if="!dataReadonly && !showInfiniteLoading">
                    <el-button size="small" class="search-btn btn-primary" @click="submitForm(2)" :disabled="saving" v-if="type == 4">转为采购订单</el-button>
                    <div v-else-if="type == 2 || type == 3 || type == 7">
                        <el-button size="small" class="search-btn btn-primary" @click="submitForm(type, 0)" :disabled="saving" v-if="permission.saveOrder && type != 7"
                            >保存采购订单</el-button
                        >
                        <el-button size="small" class="search-btn btn-primary" @click="submitForm(type, 1)" :disabled="saving" v-if="permission.submitOrder"
                            >提交采购订单</el-button
                        >
                    </div>
                </div>
            </div>
        </div>
        <!--    新增供应商    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑供应商' : '新增供应商'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--    财务付款    -->
        <el-dialog :close-on-click-modal="false" :title="type == 5 ? '申请付款' : '付款记录'" :visible.sync="ReceiptVisible" width="1300px">
            <div class="dialog-content" v-if="ReceiptVisible">
                <payment ref="receipt" @closeReceipt="closeReceipt" :orderData="submitData" :type="type"></payment>
            </div>
        </el-dialog>
        <!--    入仓    -->
        <el-dialog :close-on-click-modal="false" title="入仓" :visible.sync="outVisible" width="1000px">
            <div v-if="outVisible">
                <warehouseIn
                    :tcrkType="tcrkType"
                    :EntpCusPOId="submitData.EntpCusPOId"
                    :APList="warehouseGoodsList"
                    :OrderWarehouse="warehouseList.length > 0 ? warehouseList[0] : null"
                    @closeDialog="closeOutDialog"
                ></warehouseIn>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="添加仓库地址"
            :before-close="clearAddressDialog"
            :visible.sync="addressDialogVisible"
            custom-class="base-dialog"
            width="800px"
        >
            <addAddress ref="addAddress" :submitType="1" @resetData="clearAddressDialog"></addAddress>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :title="SaleDialogTitle" :visible.sync="showSaleStatDialog" :append-to-body="true" width="1300px">
            <div v-if="showSaleStatDialog">
                <saleStat @closeDialog="closeSaleStatDialog" :APId="this.APId"></saleStat>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import warehouseIn from '@/components/business/goods/warehouseIn';
import customerEdit from '@/components/business/customerManage/customerEdit';
import payment from '@/components/business/goods/payment';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import mixin from '@/mixins/mixin';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import addAddress from '@/components/common/addAddress';
import saleStat from '@/components/business/revenue/apSaleStat';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        payment,
        warehouseIn,
        searchAP,
        APMsg,
        breadcrumb,
        APPurchaseHistory,
        addAddress,
        saleStat
    },
    data() {
        let checkPhone = this.$util.checkPhone;
        let checkPositive = this.$util.checkPositive;
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            submitStorageName: 'transToSupplierOrder',
            dataStorageName: 'transToSupplierOrder_dataList',
            userMsg: userMsg,
            historyVisible: false,
            EntpTempGoodsIdEdit: '',
            customerEditType: 1,
            needConfirm: true,
            ReceiptVisible: false,
            dialogVisible: false,
            APMsgVisible: false,
            searchVisible: false,
            addressDialogVisible: false,
            outVisible: false,
            showOrderMsg: true,
            warehouseGoodsList: [], //入库商品列表
            saving: false,
            dataReadonly: false,
            allNum: 1,
            allMoney: 0,
            lack: false, // 库存是否紧缺
            editIndex: -1,
            loading: false,
            canNotEditAddr: false,
            SIdList: [],
            submitData: {
                SId: userMsg.EmployeeId,
                SubmissionState: false,
                EntpCusPOId: '',
                UserId: userMsg.EmployeeId,
                ShipAmount: '',
                EntpCusId: '',
                PayType: null,
                ShipType: null,
                AddressId: null,
                PhoneNum: '',
                Remark: '',
                DetailList: [],
                Sources: 0, //采购单来源 0 是直接采购；1 是库存需求转化的采购订单；2 销售单转化采购订单；3 询价转化的采购订单
                Bank: '',
                AccountName: '',
                Account: '',
                AddressName: '',
                WarehouseId: '',
                WarehouseAddr: ''
            },
            Limit: 10,
            download_url: this.$util.QN_URL_BASE,
            customerList: [],
            DeliveryMethodList: [], // 发货方式列表
            payWayList: [],
            addressList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            unitList: [],
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [
                    {
                        required: true,
                        message: '填选择供应商',
                        trigger: 'change'
                    }
                ],
                PhoneNum: [
                    {
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: '请填写手机号',
                        trigger: 'blur'
                    }
                ],
                AddressId: [
                    {
                        required: true,
                        message: '填写收货地址',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        validator: checkPositive,
                        trigger: 'blur'
                    }
                ],
                PayType: [
                    {
                        required: true,
                        message: '填写结算方式',
                        trigger: 'blur'
                    }
                ],
                WarehouseId: [
                    {
                        required: true,
                        message: '请选择仓库',
                        trigger: 'blur'
                    }
                ],
                WarehouseAddr: [{ required: true, message: '请填写仓库地址', trigger: 'blur' }]
            },
            permission: {},
            permission3: {},
            warehouseList: [], //仓库地址

            startIdx: 0, // 列表显示的第一个列的下标
            endIdx: 49, // 列表显示的最后一个列的下标
            stopLoad: false, // 停止监听上下滚动
            windowHeight: window.innerHeight,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            scrollPosition: 0, // 滚动条位置，用于判断是否收起信息栏,
            showSaleStatDialog: false,
            SaleDialogTitle: '',
            tcrkType: 0, // 弹框模式，1 同仓入库，0 单个入仓
            changeCodeConfig: false,
            canInStorages: false //通过计算已入仓数和标签数得出
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        this.getSendWay();
        this.getPay();
        this.getSIdList();
    },
    mounted() {
        let fullPath = this.$route.fullPath;
        document.onkeydown = event => {
            let isDialog = document.querySelector('.v-modal');
            let layui = document.querySelectorAll('.layui-layer');
            if (
                fullPath == this.$route.fullPath &&
                !this.ReceiptVisible &&
                !this.dialogVisible &&
                !this.APMsgVisible &&
                !this.searchVisible &&
                !this.outVisible &&
                !isDialog &&
                layui.length <= 1
            ) {
                let e = event || window.event || arguments.callee.caller.arguments[0];
                if (e && e.keyCode == 13) {
                    // this.addItem(true);
                }
            }
        };
        this.permission = this.$util.getPermission('supplierBuyOrder');
        this.permission3 = this.$util.getPermission('purchasesOrderTakeIn');
        this.uploadImgData = {
            OrderId: this.$route.query.id,
            OrderType: 1
        };

        this.id = this.$route.query.id;
        this.submitData.EntpCusPOId = this.$route.query.id;
        this.type = this.$route.query.type;
        let localStorage = null;
        switch (Number(this.type)) {
            case 1:
                this.pageTitle = '查看采购单';
                this.dataReadonly = true;
                this.getOrderDetail();
                break;
            case 2:
                this.pageTitle = '编辑采购单';
                this.getChangeCodeConfig();
                localStorage = this.loadStorage();
                if (localStorage) {
                    this.getDataFromChace(localStorage);
                } else {
                    this.getOrderDetail();
                }
                break;
            case 3:
                this.pageTitle = '新增采购单';
                this.getChangeCodeConfig();
                //判断缓存是否有数据，如果有取缓存数据
                localStorage = this.loadStorage();
                if (localStorage) {
                    this.getDataFromChace(localStorage);
                } else {
                    this.addItem(false);
                    this.getdefaultWarehouses();
                }

                break;
            case 4:
                this.pageTitle = '转为采购单';
                this.getChangeCodeConfig();
                this.getBJOrder();
                break;
            case 5:
                this.needConfirm = false;
                this.pageTitle = '财务付款';
                this.getOrderDetail();
                break;
            case 6:
                this.needConfirm = false;
                this.pageTitle = '货物入仓';
                this.getOrderDetail();
                break;
            case 7:
                this.pageTitle = '修改采购单';
                this.getChangeCodeConfig();
                localStorage = this.loadStorage();
                if (localStorage) {
                    this.getDataFromChace(localStorage);
                } else {
                    this.getOrderDetail();
                }
                break;
            default:
                break;
        }

        // 监听滚动事件
        document.addEventListener('scroll', this.loadTopScroll, true);
        window.onresize = () => {
            this.resetHeight();
        };
        // 给business-content强行写入css样式
        let bc = document.getElementsByClassName('business-content')[0];
        bc.style.overflow = 'hidden';
        bc.style.scrollbarWidth = 'none';
        setTimeout(() => {
            this.resetHeight();
        }, 0);
    },
    destroyed() {
        document.removeEventListener('scroll', this.loadTopScroll, true);
        let bc = document.getElementsByClassName('business-content')[0];
        if (bc) {
            bc.style.overflow = 'auto';
            bc.style.scrollbarWidth = 'auto';
        }
    },
    watch: {
        showOrderMsg() {
            let topValue = document.getElementById('infinite-list').scrollTop;
            this.scrollPosition = topValue;
        }
    },
    computed: {
        // 是否显示loading
        showInfiniteLoading() {
            return this.endIdx < this.dataList.length - 1;
        }
    },
    methods: {
        /**
         * 向上滚动
         * topValue: 距离顶部距离
         */
        loadTopScroll() {
            if (!document.getElementById('infinite-list')) return;
            let topValue = document.getElementById('infinite-list').scrollTop;
            if (this.showOrderMsg && topValue > this.scrollPosition) {
                this.scrollPosition = topValue;
                this.hideMsg();
            }
            if (topValue > 150 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.startIdx > 0) {
                if (this.startIdx < 25) {
                    let over = this.startIdx;
                    this.startIdx -= Math.abs(over);
                    this.endIdx -= Math.abs(over);
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您现在在顶部'
                    });
                } else if (this.startIdx >= 25) {
                    this.startIdx -= 25;
                    this.endIdx -= 25;
                    if (this.startIdx === 0) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您现在在顶部'
                        });
                    } else {
                        // 对火狐浏览器做特殊处理
                        if (navigator.userAgent.indexOf('Firefox') >= 0) {
                            let sh = document.getElementById('infinite-list').scrollHeight / 4;
                            document.getElementById('infinite-list').scrollTop = sh;
                        }
                    }
                }
            }
            this.stopLoad = false;
        },
        // 向下滚动
        loadDownScroll() {
            let listLastIndex = this.dataList.length - 1;
            if (listLastIndex < 50 || this.stopLoad) return;
            this.stopLoad = true;
            if (this.endIdx < listLastIndex) {
                if (this.endIdx + 25 <= listLastIndex) {
                    this.startIdx += 25;
                    this.endIdx += 25;
                    if (this.endIdx === this.listLastIndex) {
                        this.$message({
                            type: 'info',
                            offset: this.windowHeight / 2,
                            message: '您已经触底了哦~'
                        });
                    }
                } else {
                    let over = this.endIdx;
                    this.startIdx += listLastIndex - over;
                    this.endIdx += listLastIndex - over;
                    this.$message({
                        type: 'info',
                        offset: this.windowHeight / 2,
                        message: '您已经触底了哦~'
                    });
                }
            }
            this.stopLoad = false;
        },
        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top;
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog(items) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                that.searchVisible = false;
                return;
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let goods = that.dataList.find(e => item.APCode == e.APCode);
                if (!goods) {
                    let newGoods = {
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        AutoSeriseItem: item.AutoSerise,
                        Count: 1,
                        Price: item.Price ? item.Price : '',
                        Unit: item.Unit,
                        Remark: item.Remark,
                        CodeRepeat: false,
                        WarehousedCount: 0,
                        State: 0
                    };
                    newGoodsList.push(newGoods);
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }

            that.priceChange();
            that.searchVisible = false;
            that.$nextTick(() => {
                if (that.$refs['count' + (that.dataList.length - 1).toString()]) {
                    that.$refs['count' + (that.dataList.length - 1).toString()][0].focus();
                }
            });
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        closeOutDialog(edit, IsAllInWarehouse) {
            this.outVisible = false;
            this.needConfirm = false;
            if (IsAllInWarehouse) {
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
                return;
            }
            if (edit) {
                this.getOrderDetail();
            }
        },
        checkCodeRepeat() {
            let repeatIndexs = [];
            let obj = {};
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                _dataList[i].CodeRepeat = false;
                if (!obj[_dataList[i].APCode]) {
                    obj[_dataList[i].APCode] = [i];
                } else {
                    obj[_dataList[i].APCode].push(i);
                }
            }
            for (let key in obj) {
                if (obj[key].length >= 2) {
                    repeatIndexs = [...repeatIndexs, ...obj[key]];
                }
            }
            for (let j = 0; j < repeatIndexs.length; j++) {
                this.dataList[repeatIndexs[j]].CodeRepeat = true;
            }
        },
        // 入仓
        inputWarehouse(item) {
            this.warehouseGoodsList = [];
            if (item) {
                this.warehouseGoodsList.push({ ...item }); // 单个入仓
                this.tcrkType = 0;
            } else {
                this.warehouseGoodsList = [...this.dataList]; // 整单入仓
                this.tcrkType = 1;
            }
            this.outVisible = true;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _lack = false; // 库存是否紧缺
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
            this.lack = _lack;
            this.dataList = DetailList;
        },
        showReceipt() {
            this.ReceiptVisible = true;
        },
        closeReceipt(edit) {
            this.ReceiptVisible = false;
            this.needConfirm = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        // 询价单转采购单详情
        getBJOrder() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpInquiryOrder',
                    data: {
                        InquiryId: this.id,
                        EntpId: this.userMsg.EntpId
                    }
                })
                .then(res => {
                    let DetailList = res.data.DetailList;
                    res.data.EntpCusPOIds = this.id;
                    res.data.UserId = this.userMsg.EmployeeId;
                    res.data.SId = this.userMsg.EmployeeId;
                    res.data.WarehouseId = '';
                    res.data.WarehouseAddr = '';
                    this.submitData = res.data;
                    let _allNum = 0;
                    let _allMoney = 0;
                    for (let i = 0; i < DetailList.length; i++) {
                        this.$set(DetailList[i], 'Price', DetailList[i].MarketPrice);
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].Price ? DetailList[i].Count * DetailList[i].Price : 0;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;
                    }
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;
                });
        },
        // 获取详情
        getOrderDetail() {
            this.$util
                .axiosGet({
                    url:
                        this.type == 7
                            ? '/api/EntpPurchaseOrder/GetEntpPurOrderAfterSubmit'
                            : '/api/EntpPurchaseOrder/GetEntpPurOrderDetails',
                    data: {
                        EntpCusPOId: this.id,
                        Type: this.type
                    }
                })
                .then(res => {
                    let data = res.data;
                    let DetailList = data.DetailList;
                    data.EntpCusPOIds = this.id;
                    data.SubmissionState = Boolean(data.SubmissionState);
                    data.UserId = this.userMsg.EmployeeId;
                    this.submitData = data;

                    let _allNum = 0;
                    let _allMoney = 0;
                    let checkIsInStorage = Number(this.type) == 6;
                    this.canInStorages = this.submitData.IsInStorage;
                    for (let i = 0; i < DetailList.length; i++) {
                        _allNum += Number(DetailList[i].Count);
                        _allMoney += DetailList[i].Count * DetailList[i].Price ? DetailList[i].Count * DetailList[i].Price : 0;
                        DetailList[i].AutoSeriseItem = DetailList[i].AutoSerise;

                        if (checkIsInStorage) {
                            let canIn =
                                DetailList[i].WarehousedCount > DetailList[i].InLabelCount
                                    ? DetailList[i].Count - DetailList[i].PrintCount - (DetailList[i].WarehousedCount - DetailList[i].InLabelCount) > 0
                                    : DetailList[i].Count - DetailList[i].PrintCount > 0;
                            //找到一个后面就不需要再查了
                            if (canIn) {
                                this.canInStorages = true;
                                checkIsInStorage = false;
                            }
                        }
                    }
                    this.orderImages = data.OrderImages;
                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }
                    // 判断是否可编辑
                    if (this.type != 2 && this.type != 3 && this.type != 7) this.dataReadonly = true;

                    this.customerList.push({
                        EntpCusId: res.data.EntpCusId,
                        EntpCusName: res.data.EntpCusName
                    });
                    this.SIdList.push({
                        EmployeeId: res.data.SId,
                        EmployeeName: res.data.SName
                    });
                    this.allMoney = _allMoney;
                    this.allNum = _allNum;
                    this.dataList = DetailList;

                    this.$set(this.submitData, 'WarehouseAddr', data.ShipAddr);
                    // if (data.Warehouse) {
                    //   this.warehouseList.push({
                    //     WarehouseId: data.Warehouse.WarehouseId,
                    //     WarehouseName: data.Warehouse.WarehouseName,
                    //     Address: data.Warehouse.Address
                    //   });
                    //   this.$set(
                    //     this.submitData,
                    //     "WarehouseId",
                    //     data.Warehouse.WarehouseId
                    //   );
                    //   this.$set(
                    //     this.submitData,
                    //     "WarehouseName",
                    //     data.Warehouse.WarehouseName
                    //   );
                    //   this.submitData.ShipAddr = data.ShipAddr; //只用于条件判断，无其他用途
                    // }
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Address: data.Warehouse.Address,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                        this.submitData.ShipAddr = data.ShipAddr; //只用于条件判断，无其他用途
                    } else {
                        this.getdefaultWarehouses();
                    }
                });
        },
        // 提交采购单
        submitForm(type, SubmissionState) {
            let that = this;
            this.$refs['formMsg'].validate(valid => {
                if (valid) {
                    let _dataList = this.dataList;
                    if (!this.submitData.EntpCusId && this.type != 4) {
                        this.$util.warningMsg('请选择供应商');
                        this.showMsg();
                        return;
                    }
                    if (_dataList.length == 0) {
                        this.$util.warningMsg('您还未选择任何的商品数据哟');
                        return;
                    }                    
                    for (let i = 0; i < _dataList.length; i++) {
                        if (!_dataList[i].APCode) {
                            this.$util.warningMsg('请填写配件编码');
                            return;
                        }
                        if (!_dataList[i].GoodName) {
                            this.$util.warningMsg('请填写配件名称');
                            return;
                        }
                        if (_dataList[i].State != 0) {
                            this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                            return;
                        }
                        if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                            this.$util.warningMsg('请填写正确的配件数量');
                            return;
                        }
                        if (!_dataList[i].AutoSerise) {
                            this.$util.warningMsg('请填写车型');
                            return;
                        }
                        if (!_dataList[i].Unit) {
                            this.$util.warningMsg('请填写单位');
                            return;
                        }
                        if (!_dataList[i].Price || _dataList[i].Price < 0) {
                            this.$util.warningMsg('请填写正确的采购价');
                            return;
                        }
                    }
                    this.submitData.DetailList = _dataList;
                    if (this.saving) {
                        return;
                    }
                    this.saving = true;
                    if (SubmissionState) {
                        this.submitData.SubmissionState = SubmissionState;
                    }
                    if (type == 3) this.submitData.Sources = 0;
                    else this.submitData.Sources = 3;

                    let url = '';
                    switch (Number(type)) {
                        case 2: // 2 是编辑（未提交前）；
                        case 3: // 3 是新增；
                            url = '/api/EntpPurchaseOrder/SaveEntpPurOrder';
                            break;
                        case 7: // 7 是修改采购单
                            url = '/api/EntpPurchaseOrder/SavePurOrderAfterSubmit';
                            break;
                        default:
                            url = '/api/EntpInquiryOrder/TransInquiryOToPurO';
                            break;
                    }
                    this.$util
                        .axiosPost({
                            url: url,
                            data: this.submitData
                        })
                        .then(() => {
                            this.$store.commit('updateNeedRefresh', true);
                            this.needConfirm = false;
                            if (type == 2 || type == 3) {
                                if (SubmissionState == 0) this.$util.successMsg('保存采购订单成功');
                                else this.$util.successMsg('提交采购订单成功');
                            } else if (type == 7) {
                                this.$util.successMsg('修改采购订单成功');
                            } else {
                                this.$util.successMsg('转为采购订单成功');
                            }

                            this.removePageChace();

                            //添加默认入仓仓库
                            if (that.submitData.WarehouseId) {
                                var wd= {
                                        WarehouseId: that.submitData.WarehouseId,
                                        WarehouseName: that.submitData.WarehouseName,
                                        Address: that.submitData.WarehouseAddr,
                                        WarehouseType: that.warehouseType
                                        };
                                let CacheList=[];        
                                CacheList.push({CacheKey:'defaultInWarehouses',CacheValue:JSON.stringify(wd)});
                                that.$util.SetEntpCache(CacheList);                        
                            }                                

                            setTimeout(() => {
                                this.$router.push('/purchaseManage/purchaseOrders');
                            }, 2000);
                        })
                        .catch(() => {
                            this.saving = false;
                        });
                } else {
                    this.$util.warningMsg('有必填项未填写');
                    this.showMsg();
                }
            });
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.priceChange();
        },
        // 添加一行
        addItem(addPageChace) {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    this.$util.warningMsg('请填写正确的配件数量');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!_dataList[i].Price || _dataList[i].Price < 0) {
                    this.$util.warningMsg('请填写正确的采购价');
                    return;
                }
            }
            if (addPageChace) {
                this.addPageChace(); //添加采购订单缓存
            }

            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: '1',
                Price: '',
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                WarehousedCount: 0,
                State: 0
            });

            // 当dataList数量大于50时
            if (this.dataList.length > 50) {
                this.startIdx += 1;
                this.endIdx += 1;
            }

            // 新增一行数据的时候，元素定位到底部
            setTimeout(() => {
                let ilEle = document.getElementById('infinite-list');
                ilEle.scrollTop = ilEle.scrollHeight + 50;
            }, 0);

            this.priceChange();
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let transOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (transOrderModel && datalist && datalist.length > 0) {
                return {
                    model: transOrderModel,
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace(data) {
            let transOrderModel = data.model;
            let datalist = data.list;

            if (transOrderModel) {
                this.searchCustomer();
                // this.getAddressList();
                this.submitData = transOrderModel;
                if (transOrderModel.WarehouseId) {
                    this.warehouseList.push({
                        WarehouseId: transOrderModel.WarehouseId,
                        WarehouseName: transOrderModel.WarehouseName,
                        Address: transOrderModel.WarehouseAddr
                    });
                }
            }
            if (transOrderModel && transOrderModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: transOrderModel.WarehouseId,
                    WarehouseName: transOrderModel.WarehouseName,
                    Type: transOrderModel.WarehouseType
                });
            } else {
                this.getdefaultWarehouses();
            }
            if (datalist && datalist.length > 0) {
                let _lack = false; // 库存是否紧缺
                let _allNum = 0;
                let _allMoney = 0;
                for (let i = 0; i < datalist.length; i++) {
                    // datalist[i].MarketPrice = datalist[i].Price;
                    _allNum += Number(datalist[i].Count);
                    _allMoney += datalist[i].Count * datalist[i].MarketPrice ? datalist[i].Count * datalist[i].MarketPrice : 0;
                    if (datalist[i].Inventory - datalist[i].WaitingOutQuantity <= 0) {
                        _lack = true;
                    }
                }
                this.allMoney = _allMoney;
                this.allNum = _allNum;
                this.lack = _lack;
                this.dataList = datalist;
            }
        },

        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            if (this.dataReadonly) return;
            return new Promise(resolve => {
                this.$util.GetEntpCache({CacheKey:'defaultInWarehouses'},true).then(result => {
                    if (result) {
                        let data =JSON.parse(result)
                        let isexit = this.warehouseList.find(e => e.WarehouseId == data.WarehouseId);
                        if (!isexit) {
                            this.warehouseList.push({
                                WarehouseId: data.WarehouseId,
                                WarehouseName: data.WarehouseName,
                                Type: data.WarehouseType,
                                Address:data.Address
                            });
                        }

                        this.$set(this.submitData, 'WarehouseId', data.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', data.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', data.Address);

                        this.warehouseType = data.WarehouseType;
                    }
                    resolve();
                });
            });
        },        
        /**
         * 从缓存中获取默认数据
         * ShipType 发货方式
         * PayType 结算方式
         * WarehouseAddr 收货地址
         * WarehouseId 仓库ID
         * WarehouseName 仓库名称
         */
        getDefaultData() {
            this.$util
                .axiosGet({
                    url: '/api/EntpCustomers/GetCustOrderNewsData',
                    data: {
                        cid: this.submitData.EntpCusId,
                        type: '1',
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (data) {
                        let dIndex = this.DeliveryMethodList.findIndex(f => f.Value == data.ShipType);
                        if (dIndex == -1) {
                            this.DeliveryMethodList.push({
                                Value: data.ShipType,
                                Text: data.ShipTypeName
                            });
                        }
                        this.submitData.ShipType = data.ShipType;

                        dIndex = this.payWayList.findIndex(f => f.Value == data.PayType);
                        if (dIndex == -1) {
                            this.payWayList.push({
                                Value: data.PayType,
                                Text: data.PayTypeName
                            });
                        }
                        this.submitData.PayType = data.PayType;
                    }
                });
        },
        // 搜索顾客
        searchCustomer(key) {
            this.loading = true;
            this.customerList = [];

            this.$util.searchSupplier(key).then(data => {
                this.loading = false;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
                //修改客户时要更新页面上展现的名称
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.submitData.EntpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 改变商品数量
        handleNumChange(data, value, index) {
            this.dataList[index].Count = value;
        },
        // 获取地址
        getAddressList() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInfoManagement/GetAddressList',
                    data: {
                        Page: 1,
                        Limit: 999,
                        EntpId: this.userMsg.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    let _addressList = [];
                    for (let i = 0; i < data.length; i++) {
                        _addressList.push({
                            Text: `${data[i].Province}${data[i].City}${data[i].District}${data[i].Addr}`,
                            Value: data[i].Id
                        });
                    }
                    this.addressList = _addressList;
                });
        },
        // 搜索汽配编码
        searchCode(key) {
            this.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                        data: {
                            SId: this.submitData.WarehouseId,
                            APCode: key,
                            Limit: this.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.loading = false;
                        this.codeList = res.data;
                        resolve();
                    });
            });
        },
        // 搜索名称
        searchName(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        SId: this.submitData.WarehouseId,
                        GoodName: key,
                        Limit: this.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.nameList = res.data;
                    if (item) {
                        item.VGoodName = key;
                        item.GoodName = key;
                        this.seriesList = res.data;
                    }
                });
        },
        // 搜车系
        searchAutoSerie(key, item) {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        SId: this.submitData.WarehouseId,
                        GoodName: item ? item.VGoodName : '', //配合商品名称查
                        Limit: this.Limit,
                        OnlySeries: true,
                        SeriesName: key
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    this.seriesList = res.data;
                });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        // 获取发货方式
        getSendWay() {
            this.$util.getSendWay().then(data => {
                this.DeliveryMethodList = data;
            });
        },
        getChangeCodeConfig() {
            this.$util.getSysConfig('ddhhm').then(data => {
                this.changeCodeConfig = data.Result;
            });
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        // 名称改变
        nameChange(value, index) {
            this.editIndex = index;
            if (!value) {
                this.dataList[index].VGoodName = '';
                return;
            }
            // this.searchName();
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].APCode = _list[i].APCode;
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    }
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].VGoodName = _list[i].GoodName;
                    this.dataList[index].Price = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].State = 0;
                    break;
                }
            }
            this.priceChange();
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.checkCodeRepeat();
            this.editIndex = index;
            // this.searchCode();
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].APCode == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].Price = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].IsNew = false;
                    this.dataList[index].State = 0;
                    isNew = false;
                }
            }
            if (isNew && value) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].Price = 0;
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.$nextTick(() => {
                            that.$refs['code' + index][0].blur();
                        });
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                }
                            });
                    }
                });
            }
            this.priceChange();
        },
        //车型改变  AutoSeriseItem值仅仅用于选中值为对象的效果，实际上保存的数据还是AutoSerise
        seriseChange(item, index) {
            this.editIndex = index;
            if (!item) {
                this.dataList[index].AutoSerise = '';
            } else if (typeof item == 'string') {
                this.dataList[index].AutoSerise = item;
            } else {
                this.dataList[index].APCode = item.APCode;
                this.dataList[index].EntpTempGoodsId = item.EntpTempGoodsId;
                this.dataList[index].GoodName = item.GoodName;
                this.dataList[index].VGoodName = item.GoodName;
                this.dataList[index].Price = item.CostPrice;
                this.dataList[index].Unit = item.Unit;
                this.dataList[index].AutoSerise = item.AutoSerise;
                this.dataList[index].State = 0;
                this.checkCodeRepeat();
                this.priceChange();
            }
        },
        // 供应商改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
            } else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
            //因为需求改动以下几个赋值应该没有什么作用了，但仍然保存先 by qdl 2020/8/7
            this.submitData.Bank = '';
            this.submitData.AccountName = '';
            this.submitData.Account = '';
            this.getDefaultData();
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer();
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length == 0) that.searchCode();
            }
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length == 0) that.searchName();
            }
        },
        //当车系下拉框出现时触发
        autoSeriseVisibleChange(event, item) {
            let that = this;
            if (event) {
                if (that.seriesList.length == 0) that.searchAutoSerie('', item);
            }
        },
        addressVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.addressList.length <= 1) that.getAddressList();
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;

                        if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
                        else this.canNotEditAddr = false;
                        return;
                    }
                }
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        //快速添加仓库地址
        addAddress() {
            this.addressDialogVisible = true;
        },
        clearAddressDialog() {
            this.$refs.addAddress.resetForm();
            this.addressDialogVisible = false;
            this.formData = {};
            this.getAddressList();
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.EntpTempGoodsId;
                this.showSaleStatDialog = true;
            }
        },
        closeSaleStatDialog() {
            this.showSaleStatDialog = false;
        }
    }
};
</script>
<style lang="less" scoped>
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.search-ctn {
    border: 1px solid @border3Color;
    padding-top: 20px;
    margin-bottom: 20px;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.form-applyzone {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-account {
    width: 57.7%;
    float: left;
    margin-left: 30px;
    border: 1px dashed #888888;
    border-radius: 10px;
}
.inventory-title {
    line-height: 1.2;
    flex-direction: column;
    > div:nth-child(1) {
        width: 100%;
        border-bottom: 1px solid @border3Color;
    }
    > div:nth-child(2) {
        width: 100%;
        display: flex;
        > div {
            width: 33.33%;
        }
    }
}
.form-section {
    display: flex;
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.btn-ctn {
    margin-right: 110px;
    padding: 30px 0;
    text-align: right;
    padding-bottom: 180px;
}
.add-btn {
    position: absolute;
    right: 2%;
    bottom: 0;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 2px;
    z-index: 2;
}
.business-content-main {
    min-width: 1440px;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin: -1px -1px -1px 0px;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}

.addresscls {
    display: flex;
    flex-direction: row;
}
.addicon {
    height: 30px;
    margin-left: 10px;
    margin-top: 5px;
}
</style>

<style lang="less">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 20px;
    }
}
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}
.grid-content {
    border-radius: 4px;
    min-height: 36px;
}
.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
</style>
